import React from 'react';
import { BedDoubleIcon, ArrowUpIcon, PlaneIcon, CarIcon } from 'lucide-react';
export const Perks = () => {
  return <section id="perks" className="py-20 bg-limestone-800 text-white" data-id="element-557">
      <div className="container mx-auto px-6" data-id="element-558">
        <div className="text-center mb-16" data-id="element-559">
          <h2 className="text-4xl font-serif font-bold mb-4 text-white" data-id="element-560">
            Exclusive Member Perks
          </h2>
          <p className="text-lg text-limestone-100 max-w-3xl mx-auto" data-id="element-561">
            Enjoy these exclusive benefits available only to Elite Planners
            Association members.
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-562">
          <div className="bg-limestone-700 rounded-xl p-8 text-center transform transition hover:-translate-y-1 hover:shadow-limestone" data-id="element-563">
            <div className="flex justify-center mb-6" data-id="element-564">
              <div className="p-3 rounded-full bg-limestone-600" data-id="element-565">
                <BedDoubleIcon className="h-8 w-8 text-white" data-id="element-566" />
              </div>
            </div>
            <h3 className="text-xl font-bold mb-3 text-white" data-id="element-567">
              Free Room Nights
            </h3>
            <p className="text-limestone-200" data-id="element-568">
              Receive complimentary room nights at luxury resorts for site
              visits and personal vacations.
            </p>
            <div className="mt-6 text-white font-medium" data-id="element-569">
              Up to 14 nights per year
            </div>
          </div>
          <div className="bg-limestone-700 rounded-xl p-8 text-center transform transition hover:-translate-y-1 hover:shadow-limestone" data-id="element-570">
            <div className="flex justify-center mb-6" data-id="element-571">
              <div className="p-3 rounded-full bg-limestone-600" data-id="element-572">
                <ArrowUpIcon className="h-8 w-8 text-white" data-id="element-573" />
              </div>
            </div>
            <h3 className="text-xl font-bold mb-3 text-white" data-id="element-574">
              Upgraded Rooms
            </h3>
            <p className="text-limestone-200" data-id="element-575">
              Automatic room upgrades for you and your clients at partner
              resorts and hotels.
            </p>
            <div className="mt-6 text-white font-medium" data-id="element-576">
              Subject to availability
            </div>
          </div>
          <div className="bg-limestone-700 rounded-xl p-8 text-center transform transition hover:-translate-y-1 hover:shadow-limestone" data-id="element-577">
            <div className="flex justify-center mb-6" data-id="element-578">
              <div className="p-3 rounded-full bg-limestone-600" data-id="element-579">
                <PlaneIcon className="h-8 w-8 text-white" data-id="element-580" />
              </div>
            </div>
            <h3 className="text-xl font-bold mb-3 text-white" data-id="element-581">
              Travel Agent Rates
            </h3>
            <p className="text-limestone-200" data-id="element-582">
              Access special travel agent rates for flights, accommodations, and
              experiences.
            </p>
            <div className="mt-6 text-white font-medium" data-id="element-583">
              Save up to 40% on travel
            </div>
          </div>
          <div className="bg-limestone-700 rounded-xl p-8 text-center transform transition hover:-translate-y-1 hover:shadow-limestone" data-id="element-584">
            <div className="flex justify-center mb-6" data-id="element-585">
              <div className="p-3 rounded-full bg-limestone-600" data-id="element-586">
                <CarIcon className="h-8 w-8 text-white" data-id="element-587" />
              </div>
            </div>
            <h3 className="text-xl font-bold mb-3 text-white" data-id="element-588">
              Free Transportation
            </h3>
            <p className="text-limestone-200" data-id="element-589">
              Complimentary airport transfers and luxury transportation during
              site visits.
            </p>
            <div className="mt-6 text-white font-medium" data-id="element-590">
              At all partner destinations
            </div>
          </div>
        </div>
        <div className="mt-16 text-center" data-id="element-591">
          <p className="text-lg text-limestone-100 mb-6" data-id="element-592">
            And many more exclusive benefits only available to EPA members.
          </p>
          <button className="bg-white hover:bg-limestone-100 text-limestone-800 font-bold py-3 px-8 rounded-lg text-lg transition transform hover:scale-105" data-id="element-593">
            View All Perks
          </button>
        </div>
      </div>
    </section>;
};